import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { NavController } from '@ionic/angular';

export type BreadcrumbOptions = {
    label: string;
    href: string;
}

@Component({
    selector: 'breadcrumbs',
    templateUrl: './breadcrumbs.component.html',
    styleUrls: ['./breadcrumbs.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class BreadcrumbsComponent {
    @Input() breadcrumbs: BreadcrumbOptions[];

    public get backLink(): string|null {
        return this.breadcrumbs?.[this.breadcrumbs.length - 2].href ?? null;
    }
}
